import styled from 'styled-components';

import {Spinner} from 'components/ui-kit/Spinner';

import {colors, font} from 'theme';

export const Content = styled.div``;

export const Loader = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 240px;
`;

export const LoaderSpinner = styled(Spinner)`
    height: 48px;
    width: 48px;
`;

export const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const InfoCard = styled.div`
    background: ${colors.brandLight};
    border: 1px solid ${colors.brandPrimary};
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 16px;
`;

export const InfoTitle = styled.div`
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    margin-bottom: 4px;
`;

export const InfoDescription = styled.div`
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 12px;
    line-height: 16px;
`;

export const DeclarationCard = styled.div`
    background: ${colors.background};
    border: 1px solid ${colors.border};
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 12px;
    overflow-y: auto;
`;

export const DeclarationTitle = styled.div`
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 16px;
`;

export const DeclarationText = styled.div`
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 12px;
    line-height: 22px;

    p {
        margin: 0 0 12px;
    }

    p:last-child {
        margin-bottom: 0;
    }
`;

export const WarningCard = styled.div`
    background: #fff4e6;
    border: 1px solid #ffa726;
    border-radius: 8px;
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 12px;
    line-height: 16px;
    padding: 12px;
    margin-bottom: 12px;
`;

export const CheckboxCard = styled.div`
    background: ${colors.white};
    border: 1px solid ${colors.brandPrimary};
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 20px;
`;

export const CheckboxLabel = styled.span`
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
`;

export const Footer = styled.div`
    border-top: 1px solid ${colors.border};
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding-top: 20px;
    position: sticky;
    bottom: 0;
    background: ${colors.white};

    & > * {
        width: fit-content;
    }
`;
